"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedCarbonSDK = exports.Carbon = exports.DenomPrefix = exports.CarbonTx = exports.CarbonWallet = exports.CarbonSignerTypes = void 0;
const constant_1 = require("./constant");
const util_1 = require("./util");
const tendermint_rpc_1 = require("@cosmjs/tendermint-rpc");
const grpc_web_node_http_transport_1 = require("@improbable-eng/grpc-web-node-http-transport");
const clients = __importStar(require("./clients"));
const clients_1 = require("./clients");
const GrpcQueryClient_1 = __importDefault(require("./clients/GrpcQueryClient"));
const N3Client_1 = __importDefault(require("./clients/N3Client"));
const modules_1 = require("./modules");
const staking_1 = require("./modules/staking");
const provider_1 = require("./provider");
const blockchain_1 = require("./util/blockchain");
const wallet_1 = require("./wallet");
var wallet_2 = require("./wallet");
Object.defineProperty(exports, "CarbonSignerTypes", { enumerable: true, get: function () { return wallet_2.CarbonSignerTypes; } });
Object.defineProperty(exports, "CarbonWallet", { enumerable: true, get: function () { return wallet_2.CarbonWallet; } });
var util_2 = require("./util");
Object.defineProperty(exports, "CarbonTx", { enumerable: true, get: function () { return util_2.CarbonTx; } });
var constant_2 = require("./constant");
Object.defineProperty(exports, "DenomPrefix", { enumerable: true, get: function () { return constant_2.DenomPrefix; } });
exports.Carbon = __importStar(require("./codec/carbon-models"));
const DEFAULT_SDK_INIT_OPTS = {
    network: constant_1.DEFAULT_NETWORK,
};
/**
 * Carbon SDK
 *
 *
 */
class CarbonSDK {
    constructor(opts) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.network = (_a = opts.network) !== null && _a !== void 0 ? _a : constant_1.DEFAULT_NETWORK;
        this.configOverride = (_b = opts.config) !== null && _b !== void 0 ? _b : {};
        this.networkConfig = util_1.GenericUtils.overrideConfig(constant_1.NetworkConfigs[this.network], this.configOverride);
        this.useTmAbciQuery = (_c = opts.useTmAbciQuery) !== null && _c !== void 0 ? _c : false;
        this.tmClient = opts.tmClient;
        this.chainId = (_e = (_d = opts.chainId) !== null && _d !== void 0 ? _d : constant_1.CarbonChainIDs[this.network]) !== null && _e !== void 0 ? _e : constant_1.CarbonChainIDs[constant_1.Network.MainNet];
        this.evmChainId = (_g = (_f = opts.evmChainId) !== null && _f !== void 0 ? _f : constant_1.CarbonEvmChainIDs[this.network]) !== null && _g !== void 0 ? _g : constant_1.CarbonEvmChainIDs[constant_1.Network.MainNet];
        let grpcClient;
        if (opts.useTmAbciQuery !== true && this.networkConfig.grpcUrl) {
            const transport = typeof window === "undefined" ? grpc_web_node_http_transport_1.NodeHttpTransport() : undefined;
            grpcClient = (_h = opts.grpcQueryClient) !== null && _h !== void 0 ? _h : new GrpcQueryClient_1.default(this.networkConfig.grpcWebUrl, {
                transport,
            });
        }
        this.query = new clients_1.CarbonQueryClient({
            tmClient: this.tmClient,
            grpcClient,
        });
        this.insights = new clients_1.InsightsQueryClient(this.networkConfig);
        this.token = (_j = opts.token) !== null && _j !== void 0 ? _j : clients_1.TokenClient.instance(this.query, this);
        this.hydrogen = new clients_1.HydrogenClient(this.networkConfig, this.token);
        this.hydrogen = clients_1.HydrogenClient.instance(this.networkConfig, this.token);
        this.admin = new modules_1.AdminModule(this);
        this.alliance = new modules_1.AllianceModule(this);
        this.order = new modules_1.OrderModule(this);
        this.lp = new modules_1.LiquidityPoolModule(this);
        this.erc20 = new modules_1.ERC20Module(this);
        this.perpspool = new modules_1.PerpspoolModule(this);
        this.subaccount = new modules_1.SubAccountModule(this);
        this.profile = new modules_1.ProfileModule(this);
        this.cdp = new modules_1.CDPModule(this);
        this.leverage = new modules_1.LeverageModule(this);
        this.market = new modules_1.MarketModule(this);
        this.broker = new modules_1.BrokerModule(this);
        this.position = new modules_1.PositionModule(this);
        this.coin = new modules_1.CoinModule(this);
        this.oracle = new modules_1.OracleModule(this);
        this.gov = new modules_1.GovModule(this);
        this.staking = new staking_1.StakingModule(this);
        this.bank = new modules_1.BankModule(this);
        this.fee = new modules_1.FeeModule(this);
        this.ibc = new modules_1.IBCModule(this);
        this.xchain = new modules_1.XChainModule(this);
        this.evm = new modules_1.EvmModule(this);
        this.evmmerge = new modules_1.EvmMergeModule(this);
        this.feemarket = new modules_1.FeemarketModule(this);
        this.neo = clients_1.NEOClient.instance({
            configProvider: this,
            blockchain: blockchain_1.Blockchain.Neo,
        });
        this.n3 = N3Client_1.default.instance({
            configProvider: this,
            blockchain: blockchain_1.Blockchain.Neo3,
        });
        this.eth = clients_1.ETHClient.instance({
            configProvider: this,
            blockchain: blockchain_1.Blockchain.Ethereum,
            tokenClient: this.token,
        });
        this.bsc = clients_1.ETHClient.instance({
            configProvider: this,
            blockchain: blockchain_1.Blockchain.BinanceSmartChain,
            tokenClient: this.token,
        });
        this.zil = clients_1.ZILClient.instance({
            configProvider: this,
            blockchain: blockchain_1.Blockchain.Zilliqa,
        });
        this.arbitrum = clients_1.ETHClient.instance({
            configProvider: this,
            blockchain: blockchain_1.Blockchain.Arbitrum,
            tokenClient: this.token,
        });
        this.polygon = clients_1.ETHClient.instance({
            configProvider: this,
            blockchain: blockchain_1.Blockchain.Polygon,
            tokenClient: this.token,
        });
        this.okc = clients_1.ETHClient.instance({
            configProvider: this,
            blockchain: blockchain_1.Blockchain.Okc,
            tokenClient: this.token,
        });
    }
    static instance(opts = DEFAULT_SDK_INIT_OPTS) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const network = (_a = opts.network) !== null && _a !== void 0 ? _a : constant_1.DEFAULT_NETWORK;
            const configOverride = (_b = opts.config) !== null && _b !== void 0 ? _b : {};
            const networkConfig = util_1.GenericUtils.overrideConfig(constant_1.NetworkConfigs[network], configOverride);
            const batchQueryClient = new clients.BatchQueryClient(networkConfig.tmRpcUrl);
            const tmClient = (_c = opts.tmClient) !== null && _c !== void 0 ? _c : util_1.GenericUtils.modifyTmClient(yield tendermint_rpc_1.Tendermint34Client.create(batchQueryClient));
            const defaultTimeoutBlocks = opts.defaultTimeoutBlocks;
            const chainId = (_d = (yield tmClient.status())) === null || _d === void 0 ? void 0 : _d.nodeInfo.network;
            const sdk = new CarbonSDK({ network, config: configOverride, tmClient, defaultTimeoutBlocks, chainId, useTmAbciQuery: opts.useTmAbciQuery });
            if (opts.wallet) {
                yield sdk.connect(opts.wallet);
            }
            if (opts.skipInit !== true) {
                yield sdk.initialize();
            }
            return sdk;
        });
    }
    static instanceWithWallet(wallet, sdkOpts = DEFAULT_SDK_INIT_OPTS) {
        return __awaiter(this, void 0, void 0, function* () {
            const sdk = yield CarbonSDK.instance(sdkOpts);
            return sdk.connect(wallet);
        });
    }
    static instanceWithPrivateKey(privateKey, sdkOpts = DEFAULT_SDK_INIT_OPTS, walletOpts) {
        return __awaiter(this, void 0, void 0, function* () {
            const sdk = yield CarbonSDK.instance(sdkOpts);
            return sdk.connectWithPrivateKey(privateKey, walletOpts);
        });
    }
    static instanceWithMnemonic(mnemonic, sdkOpts = DEFAULT_SDK_INIT_OPTS, walletOpts) {
        return __awaiter(this, void 0, void 0, function* () {
            const sdk = yield CarbonSDK.instance(sdkOpts);
            return sdk.connectWithMnemonic(mnemonic, walletOpts);
        });
    }
    static instanceWithSigner(signer, publicKeyBase64, sdkOpts = DEFAULT_SDK_INIT_OPTS, walletOpts) {
        return __awaiter(this, void 0, void 0, function* () {
            const sdk = yield CarbonSDK.instance(sdkOpts);
            return sdk.connectWithSigner(signer, publicKeyBase64, walletOpts);
        });
    }
    static instanceWithLedger(ledger, sdkOpts = DEFAULT_SDK_INIT_OPTS, walletOpts) {
        return __awaiter(this, void 0, void 0, function* () {
            const sdk = yield CarbonSDK.instance(sdkOpts);
            return sdk.connectWithLedger(ledger, walletOpts);
        });
    }
    static instanceWithKeplr(keplr, sdkOpts = DEFAULT_SDK_INIT_OPTS, walletOpts) {
        return __awaiter(this, void 0, void 0, function* () {
            const sdk = yield CarbonSDK.instance(sdkOpts);
            return sdk.connectWithKeplr(keplr, walletOpts);
        });
    }
    static instanceWithLeap(leap, sdkOpts = DEFAULT_SDK_INIT_OPTS, walletOpts) {
        return __awaiter(this, void 0, void 0, function* () {
            const sdk = yield CarbonSDK.instance(sdkOpts);
            return sdk.connectWithLeap(leap, walletOpts);
        });
    }
    static instanceWithMetamask(metamask, sdkOpts = DEFAULT_SDK_INIT_OPTS, walletOpts, metamaskWalletOpts) {
        return __awaiter(this, void 0, void 0, function* () {
            const sdk = yield CarbonSDK.instance(sdkOpts);
            return sdk.connectWithMetamask(metamask, walletOpts, metamaskWalletOpts);
        });
    }
    static instanceViewOnly(bech32Address, sdkOpts = DEFAULT_SDK_INIT_OPTS, walletOpts) {
        return __awaiter(this, void 0, void 0, function* () {
            const sdk = yield CarbonSDK.instance(sdkOpts);
            return sdk.connectViewOnly(bech32Address, walletOpts);
        });
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            const chainId = yield this.query.chain.getChainId();
            this.chainId = chainId;
            yield this.token.initialize();
            if (this.wallet) {
                yield this.wallet.initialize(this.query);
            }
            return this;
        });
    }
    clone() {
        return new CarbonSDK(this.generateOpts());
    }
    generateOpts() {
        return {
            network: this.network,
            config: this.configOverride,
            tmClient: this.tmClient,
            chainId: this.chainId,
            useTmAbciQuery: this.useTmAbciQuery,
        };
    }
    connect(wallet) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!wallet.initialized) {
                try {
                    // Perform initialize function as per normal, but add try-catch statement to check err message
                    yield wallet.initialize(this.query);
                }
                catch (err) {
                    const errorTyped = err;
                    // In the case where account does not exist on chain, still allow wallet connection.
                    // Else, throw an error as per normal
                    if (!errorTyped.message.includes("Account does not exist on chain. Send some tokens there before trying to query sequence.")) {
                        throw new Error(errorTyped.message);
                    }
                }
            }
            this.wallet = wallet;
            return this;
        });
    }
    disconnect() {
        var _a;
        if ((_a = this.wallet) === null || _a === void 0 ? void 0 : _a.isLedgerSigner()) {
            this.wallet.signer.ledger.disconnect();
        }
        return new CarbonSDK(Object.assign(Object.assign({}, this), { wallet: null, skipInit: true }));
    }
    connectWithPrivateKey(privateKey, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = wallet_1.CarbonWallet.withPrivateKey(privateKey, Object.assign(Object.assign({}, opts), { network: this.network, config: this.configOverride }));
            return this.connect(wallet);
        });
    }
    connectWithMnemonic(mnemonic, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = wallet_1.CarbonWallet.withMnemonic(mnemonic, Object.assign(Object.assign({}, opts), { network: this.network, config: this.configOverride }));
            return this.connect(wallet);
        });
    }
    connectWithSigner(signer, publicKeyBase64, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = wallet_1.CarbonWallet.withSigner(signer, publicKeyBase64, Object.assign(Object.assign({}, opts), { network: this.network, config: this.configOverride }));
            return this.connect(wallet);
        });
    }
    connectWithLedger(ledger, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const publicKeyBuffer = yield ledger.getPubKey();
            const publicKeyBase64 = publicKeyBuffer.toString("base64");
            const wallet = wallet_1.CarbonWallet.withLedger(ledger, publicKeyBase64, Object.assign(Object.assign({}, opts), { network: this.network, config: this.configOverride }));
            return this.connect(wallet);
        });
    }
    connectWithKeplr(keplr, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainInfo = yield provider_1.KeplrAccount.getChainInfo(this);
            const chainId = chainInfo.chainId;
            yield keplr.experimentalSuggestChain(chainInfo);
            const keplrKey = yield keplr.getKey(chainId);
            yield keplr.enable(chainId);
            const wallet = wallet_1.CarbonWallet.withKeplr(keplr, chainInfo, keplrKey, Object.assign(Object.assign({}, opts), { network: this.network, config: this.configOverride }));
            return this.connect(wallet);
        });
    }
    connectWithLeap(leap, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainId = this.chainId;
            const chainInfo = yield provider_1.LeapAccount.getChainInfo(this);
            yield leap.experimentalSuggestChain(chainInfo);
            const leapKey = yield leap.getKey(chainId);
            yield leap.enable(chainId);
            const wallet = wallet_1.CarbonWallet.withLeap(leap, chainId, leapKey, Object.assign(Object.assign({}, opts), { network: this.network, config: this.configOverride }));
            return this.connect(wallet);
        });
    }
    connectWithMetamask(metamask, opts, metamaskWalletOpts) {
        return __awaiter(this, void 0, void 0, function* () {
            const evmChainId = this.evmChainId;
            const addressOptions = {
                network: this.networkConfig.network,
                bech32Prefix: this.networkConfig.Bech32Prefix,
            };
            let publicKeyBase64;
            const address = yield metamask.defaultAccount();
            if (metamaskWalletOpts === null || metamaskWalletOpts === void 0 ? void 0 : metamaskWalletOpts.publicKeyBase64) {
                publicKeyBase64 = metamaskWalletOpts === null || metamaskWalletOpts === void 0 ? void 0 : metamaskWalletOpts.publicKeyBase64;
            }
            else {
                const publicKeyHex = yield metamask.getPublicKey(address, metamaskWalletOpts === null || metamaskWalletOpts === void 0 ? void 0 : metamaskWalletOpts.publicKeyMessage);
                publicKeyBase64 = Buffer.from(publicKeyHex, 'hex').toString('base64');
            }
            const wallet = wallet_1.CarbonWallet.withMetamask(metamask, evmChainId, publicKeyBase64, addressOptions, Object.assign(Object.assign({}, opts), { network: this.network, config: this.configOverride }));
            return this.connect(wallet);
        });
    }
    connectViewOnly(bech32Address, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = wallet_1.CarbonWallet.withAddress(bech32Address, Object.assign(Object.assign({}, opts), { network: this.network, config: this.configOverride }));
            return this.connect(wallet);
        });
    }
    getConfig() {
        return this.networkConfig;
    }
    getTokenClient() {
        return this.token;
    }
    getConnectedWallet() {
        return this.checkWallet();
    }
    log(...args) {
        console.log.apply(console.log, [this.constructor.name, ...args]);
    }
    checkWallet() {
        if (!this.wallet) {
            throw new Error("wallet not connected");
        }
        return this.wallet;
    }
}
CarbonSDK.DEFAULT_NETWORK = constant_1.DEFAULT_NETWORK;
CarbonSDK.DenomPrefix = constant_1.DenomPrefix;
CarbonSDK.parseNetwork = util_1.NetworkUtils.parseNetwork;
class ConnectedCarbonSDK extends CarbonSDK {
    constructor(wallet, opts) {
        super(opts);
        this.wallet = wallet;
    }
    clone() {
        return new ConnectedCarbonSDK(this.wallet, this.generateOpts());
    }
}
exports.ConnectedCarbonSDK = ConnectedCarbonSDK;
(function (CarbonSDK) {
    CarbonSDK.Network = constant_1.Network;
    CarbonSDK.CarbonQueryClient = clients.CarbonQueryClient;
    CarbonSDK.ETHClient = clients.ETHClient;
    CarbonSDK.HydrogenClient = clients.HydrogenClient;
    CarbonSDK.InsightsQueryClient = clients.InsightsQueryClient;
    CarbonSDK.NEOClient = clients.NEOClient;
    CarbonSDK.TokenClient = clients.TokenClient;
    CarbonSDK.ZILClient = clients.ZILClient;
})(CarbonSDK || (CarbonSDK = {}));
exports.default = CarbonSDK;
